
import { Component, Vue, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import productOptionMixin from '@/mixin/productOptionStatus'
import currencyOptionMixin from '@/mixin/currencyOption'
import orderDateOptionMixin from '@/mixin/orderDateOption'

import {
  getWithdrawList,
  tableExport,
  getPaidList,
  paymentOrderStatistics,
  setOneClickChange,
  setOneClickUnfreeze,
  openClickPayfor
} from '@/api/task/withdraw'
import { notifiedStatusList, timeTypeList } from '@/utils/constant'
import { AppModule } from '@/store/modules/app'
import { dateToSeconds, getCurrentDate } from '@/utils/dateTime'
import pagination from '@/components/Pagination/index.vue'
import { delObjEmptyKey } from '@/utils'
import orderDetail from './components/orderDetail.vue'
import setOrderStatus from './components/setOrderStatus.vue'
import paidList from './components/paidList.vue'
import reject from './components/reject.vue'
import approval from './components/approval.vue'
import ApprovalMany from './components/approvalMany.vue'
import ModifyOrderStatusBulk from './components/ModifyOrderStatusBulk.vue'
import batchOrderNotify from './components/batchOrderNotify.vue'
import batchModifyFreezeOrder from './components/batchModifyFreezeOrder.vue'
import { getAccountGroupList } from '@/api/product/accountGroup'
import kick from './components/kickOut.vue'
import { Form as ElForm } from 'element-ui'
import { getType } from '@/utils/cookies'
import { getProductList } from '@/api/product/product'
import { getProductAccountList } from '@/api/product/productAccount'
// import openPayfor from './components/openPayfor.vue'
import { approvalRules } from '@/utils/rules'

@Component({
  name: 'withdrawIndex',
  components: {
    pagination,
    orderDetail,
    setOrderStatus,
    paidList,
    reject,
    approval,
    ApprovalMany,
    ModifyOrderStatusBulk,
    batchOrderNotify,
    batchModifyFreezeOrder,
    kick
    // openPayfor
  }
})
export default class extends mixins(
  productOptionMixin,
  currencyOptionMixin,
  orderDateOptionMixin
) {
  queryForm: any = {
    merchant_no: null,
    order_number: null,
    multi_order_number: null,
    multi_child_ordernumber: null,
    product_code: 'USDT-TRC20Payout',
    child_ordernumber: null,
    start_time: null,
    end_time: null,
    status: null,
    upstream_status: null,
    reverse_order: null,
    source: null,
    handle_time_unit: timeTypeList[0],
    min_amount: null,
    max_amount: null,
    min_request_amount: '',
    max_request_amount: '',
    success_start_time: null,
    success_end_time: null
  }

  private sysType: any = ''
  private amountType: string = 'Request Amount'

  setForm: any = {
    currency: '',
    status: null,
    upstream_status: null,
    remarks: null,
    google_code: ''
  }

  private sourceList: any[] = []
  private batchOrder: any[] = []
  private statusList: any[] = []
  private notifiedStatusList = notifiedStatusList
  private orderStatusList: any[] = []
  private upstreamStatusList: any[] = []
  private timeTypeList = timeTypeList
  private handleDate: any[] = []
  private sendLoading: boolean = false
  private orderList: any[] = []
  private listLoading: Boolean = false
  private loading: boolean = false
  private totalData: any = {
    volume: {},
    transactions: {}
  }
  // private total = {}
  private total = 0
  private listQuery = {
    page: 1,
    limit: 20
  }

  private currentOrdernumber: number | null = null
  private currentOrder: any | null = null
  private action: string = ''
  private drawer: boolean = false
  private dialogVisible: boolean = false
  private dialogVisible1: boolean = false
  private dialogVisible2: boolean = false
  private dialogVisible3: boolean = false
  private dialogVisible4: boolean = false
  private dialogVisible5: boolean = false
  private expandedRows: any[] = []
  private ordernumbers: any[] = []
  private requiredErr: any = ''
  private requiredDate: any = ''
  private requiredRemarks: any = ''
  private requiredStatus: any = ''
  private multilength: any = ''

  private multiChildlength: any = ''

  payForm: any = {
    currency: '',
    product: null,
    product_accounts: [],
    google_code: ''
  }
  private accountList: any[] = []
  private payList: any[] = []

  // 一键代付
  private openPayfor() {
    this.dialogVisible5 = true
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      this.ordernumbers.push(this.selectList[i].ordernumber)
    }
    if (this.ordernumbers) {
      let arr = this.ordernumbers
      this.multilength = arr
      this.queryForm.multi_order_number = arr.join(',')
    }
    this.payForm.product = null
    this.setForm.product_accounts = []
    this.requiredErr = ''
    if (this.dateType === 'Created Time' && !this.date) {
      this.date = getCurrentDate()
    }
    if (this.dateType === 'Success Time' && !this.successDate) {
      this.successDate = getCurrentDate()
    }
    // this.getPayProductList()
  }

  // 获取产品列表
  // private async getPayProductList() {
  //   const data: any = {
  //     in_or_out: 0,
  //     currency: AppModule.currentCurrencyType
  //   }
  //   await getProductList(data).then((res: any) => {
  //     this.payList = res
  //   })
  // }

  // 获取产品账户列表
  private async getAccountList() {
    const params = {
      product: this.payForm.product,
      status: 1,
      type: this.type,
      page: 1,
      page_size: 1000
    }
    await getProductAccountList(params).then((res: any) => {
      this.accountList = res.results
    })
  }

  private arr: any = []
  private antAccountList: any = []
  private async remoteMethod(query) {
    if (query !== '') {
      const data: any = {
        name: query,
        product: this.setForm.product,
        type: this.type
      }
      await getProductAccountList(data).then((res: any) => {
        this.antAccountList = res.results.filter(
          item => !this.accountList.some(item2 => item2.id === item.id)
        )
      })
    }
  }
  private changeArr(val) {
    // if (this.accountList.length > 1) {
    //   this.removeArr(val)
    // }
    let indexLen: number = val.length
    val.forEach((item, index, arr) => {
      let itemArr: any = item.split(',')
      let obj: any = {}
      obj.id = itemArr[0] - 0
      obj.account_name = itemArr[1]
      obj.state = itemArr[2] - 0
      obj.account_type = itemArr[3]
      if (indexLen - 1 === index) {
        this.accountList.push(obj)
      }
    })
    const map = new Map()
    this.accountList = this.accountList.filter(
      v => !map.has(v.id) && map.set(v.id, 1)
    )
    console.log(this.accountList, 'ooo')
  }
  private itemArr: any = []
  private removeArr(val) {
    this.itemArr = val.split(',')
    this.accountList = this.accountList.filter(item => {
      return item.id !== this.itemArr[0] - 0
    })
  }

  private selProductType() {
    if (this.type === 'ant') {
      // this.accountList = []
      // this.payForm.product_accounts = []
      this.arr = []
    }
    // if (this.type === 'normal') {
    //   this.getAccountList()
    //   // this.payForm.product_accounts = []
    // }
  }

  @Watch('payForm.product', { immediate: true })
  private productChange() {
    if (this.payForm.product) {
      this.checkPlatformAll = false
      this.payForm.product_accounts = []
    }
  }

  private checkPlatformAll: boolean = false
  private isIndeterminatePlatform: boolean = false
  private platformCheckAllChange(val: any) {
    this.accountList.forEach(item => {
      this.payForm.product_accounts.push(item.id)
    })
    this.payForm.product_accounts = val ? this.payForm.product_accounts : []
    this.isIndeterminatePlatform = false
  }
  private handleCheckedPlatformChange(value: any) {
    let checkedCount = value.length
    this.checkPlatformAll = checkedCount === this.accountList.length
    this.isIndeterminatePlatform =
      checkedCount > 0 && checkedCount < this.accountList.length
  }

  private selProduct() {
    this.payForm.product_accounts = []
    // this.getAccountList()
    if (this.type === 'normal') {
      this.getAccountList()
    }
  }
  private type: string = 'normal'

  private payRules = approvalRules

  // 一键代付
  private onePayfor() {
    if (
      this.queryForm.multi_order_number &&
      this.queryForm.multi_order_number.substr(-1) === ','
    ) {
      this.queryForm.multi_order_number =
        this.queryForm.multi_order_number.replace(/\S{1}$/, '')
    }
    if (
      this.queryForm.multi_child_ordernumber &&
      this.queryForm.multi_child_ordernumber.substr(-1) === ','
    ) {
      this.queryForm.multi_child_ordernumber =
        this.queryForm.multi_child_ordernumber.replace(/\S{1}$/, '')
    }
    if (!this.queryForm.status) {
      this.requiredErr = 'Query status is required'
    } else {
      ;(this.$refs.payForm as ElForm).validate(async (valid: boolean) => {
        if (valid) {
          try {
            this.loading = true
            this.flag = true
            const data: any = {
              ...this.payForm,
              filters: {
                order_number: this.queryForm.order_number,
                child_ordernumber: this.queryForm.child_ordernumber,
                merchant_no: this.queryForm.merchant_no,
                min_amount: this.queryForm.min_amount,
                max_amount: this.queryForm.max_amount,
                source: this.queryForm.source,
                start_time: this.queryForm.start_time,
                end_time: this.queryForm.end_time,
                multi_order_number: this.queryForm.multi_order_number,
                multi_child_ordernumber: this.queryForm.multi_child_ordernumber,
                status: this.queryForm.status,
                upstream_status: this.queryForm.upstream_status,
                success_start_time: this.queryForm.success_start_time,
                success_end_time: this.queryForm.success_end_time,
                handle_time_unit: timeTypeList[0],
                need_approval: true
              }
            }
            delObjEmptyKey(data)
            await openClickPayfor(data).then(() => {
              this.$message({
                message: 'Operation successfully!',
                type: 'success'
              })
              this.loading = false
              this.flagStr()
              this.closeOnePay()
            })
          } catch (e) {
            this.loading = false
            this.flagStr()
          }
        }
      })
    }
  }

  private changeOrder(val: any) {
    if (val) {
      let str = val.replace(/\n|\r\n/g, ',')
      let str1 = false
      str1 = str.includes('，')
      if (str1) {
        str = val.replace(/\，/g, ',')
      }
      // 转成数组并去掉空值
      this.multilength = str.split(',')
      this.multilength = this.multilength.filter((item: any) => {
        return item !== ''
      })
      let pattern = /([。！？；,.!?;，])\1$/
      if (pattern.test(str)) {
        let newStr = str.replace(pattern, '')
        this.queryForm.multi_order_number = newStr.split(',').join(',')
      } else {
        this.queryForm.multi_order_number = str.split(',').join(',')
      }
    } else {
      this.multilength = ''
    }
  }

  private changeChildOrder(val: any) {
    if (val) {
      let str = val.replace(/\n|\r\n/g, ',')
      let str1 = false
      str1 = str.includes('，')
      if (str1) {
        str = val.replace(/\，/g, ',')
      }
      // 转成数组并去掉空值
      this.multiChildlength = str.split(',')
      this.multiChildlength = this.multiChildlength.filter((item: any) => {
        return item !== ''
      })
      let pattern = /([。！？；,.!?;，])\1$/
      if (pattern.test(str)) {
        let newStr = str.replace(pattern, '')
        this.queryForm.multi_child_ordernumber = newStr.split(',').join(',')
      } else {
        this.queryForm.multi_child_ordernumber = str.split(',').join(',')
      }
    } else {
      this.multiChildlength = ''
    }
  }

  private changeStatus() {}

  // 跳转地址
  private jumpAddress(row) {
    if (row.withdraw_info.coin_type === 'TRC20') {
      window.open(
        `https://tronscan.io/#/address/${row.withdraw_info.address}/transfers`
      )
    } else if (row.withdraw_info.coin_type === 'ERC20') {
      window.open(`https://etherscan.io/address/${row.withdraw_info.address}`)
    }
  }
  private hashJump(row) {
    if (row.product_account_type === 'trc20') {
      window.open(
        `https://tronscan.io/#/transaction/${row.upstream_ordernumber}`
      )
    } else if (row.product_account_type === 'erc20') {
      window.open(`https://etherscan.io/tx/${row.upstream_ordernumber}`)
    } else {
      window.open(
        `https://tronscan.io/#/transaction/${row.upstream_ordernumber}`
      )
    }
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private subOrderList: any[] = []
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      delObjEmptyKey(data)
      this.orderList = []
      await getWithdrawList(data).then((res: any) => {
        this.orderList = res.results
        this.orderList.forEach((item: any) => {
          this.$set(item, 'subOrderList', [])
          if (this.expandedRows.indexOf(item.ordernumber) !== -1) {
            this.getPaidList(item)
          }
        })
        this.total = res.count
        this.listLoading = false
        this.currentPage = this.currentPage
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private isDisabled(row, index) {
    return (row.status === 1 || row.status === 5) && row.notify_status !== 1
  }

  private selectList: any[] = []
  private handleSelectionChange(list) {
    this.selectList = list
  }

  private changeAmount() {
    this.queryForm.min_request_amount = null
    this.queryForm.max_request_amount = null
    this.queryForm.min_amount = null
    this.queryForm.max_amount = null
  }

  private openDialog(action: string, param: any | null) {
    if (param) {
      this.currentOrder = param
      this.currentOrder.status_display = this.orderStatusList[param.status].text
    }
    this.action = action
    this.dialogVisible = true
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      this.ordernumbers.push(this.selectList[i].ordernumber)
    }
  }

  // 批量发送订单回调
  private openDialog4() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      if (this.selectList[i].status === 1 || this.selectList[i].status === 5) {
        this.ordernumbers.push(this.selectList[i].ordernumber)
      }
    }
    this.dialogVisible4 = true
  }

  // 批量修改冻结订单状态
  private openDialog3() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      if (this.selectList[i].status === 3) {
        this.ordernumbers.push(this.selectList[i].ordernumber)
      }
    }
    this.dialogVisible3 = true
  }
  // 批量修改订单状态
  private openDialog2() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      if (this.selectList[i].status === 2) {
        this.ordernumbers.push(this.selectList[i].ordernumber)
      }
    }
    this.dialogVisible2 = true
  }
  // 批量支付
  // private openDialog1() {
  //   this.ordernumbers = []
  //   for (let i = 0; i < this.selectList.length; i++) {
  //     if (this.selectList[i].status === 2) {
  //       this.ordernumbers.push(this.selectList[i].ordernumber)
  //     }
  //   }
  //   this.dialogVisible1 = true
  // }

  // 踢出队列
  private opnekickOut: boolean = false
  private openKickOut() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      if (this.selectList[i].is_in_queue !== null) {
        this.ordernumbers.push(this.selectList[i].ordernumber)
      }
    }
    this.opnekickOut = true
  }

  @Watch('queryForm.currency', { immediate: true })
  private watchCurrency() {
    this.setForm.currency = this.queryForm.currency
    this.payForm.currency = this.queryForm.currency
  }

  // 一键式变化
  private opnekickChangeShow: boolean = false
  private opnekickChange() {
    this.opnekickChangeShow = true
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      this.ordernumbers.push(this.selectList[i].ordernumber)
    }
    if (this.ordernumbers) {
      let arr = this.ordernumbers
      this.multilength = arr
      this.queryForm.multi_order_number = arr.join(',')
    }
    this.setForm.status = null
    this.setForm.remarks = null
    this.setForm.google_code = ''
    this.requiredErr = ''
    this.requiredDate = ''
    this.requiredRemarks = ''
    this.requiredStatus = ''
    if (this.dateType === 'Created Time' && !this.date) {
      this.date = getCurrentDate()
    }
    if (this.dateType === 'Success Time' && !this.successDate) {
      this.successDate = getCurrentDate()
    }
  }

  // 一键解冻
  private opnekickUnfreezeShow: boolean = false
  private opnekickUnfreeze() {
    this.opnekickUnfreezeShow = true
    this.setForm.status = null
    this.setForm.remarks = null
    this.setForm.google_code = ''
    this.requiredErr = ''
    this.requiredDate = ''
    this.requiredRemarks = ''
    this.requiredStatus = ''
    if (this.dateType === 'Created Time' && !this.date) {
      this.date = getCurrentDate()
    }
    if (this.dateType === 'Success Time' && !this.successDate) {
      this.successDate = getCurrentDate()
    }
  }

  private closeOpnekickUnfreeze() {
    this.opnekickUnfreezeShow = false
    this.setForm.status = null
    this.setForm.remarks = null
    this.setForm.google_code = ''
    this.queryForm.multi_order_number = ''
    this.queryForm.multi_child_ordernumber = ''
    this.multilength = ''
    this.multiChildlength = ''
  }

  private async saveClickUnfreeze() {
    if (!this.queryForm.status) {
      this.requiredErr = 'Query status is required'
    } else if (
      this.queryForm.status &&
      (!this.setForm.remarks || !this.setForm.status)
    ) {
      this.requiredRemarks = 'Remarks is required'
      this.requiredStatus = 'Status is required'
    } else {
      ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
        if (valid) {
          this.loading = true
          this.flag = true
          if (
            this.queryForm.multi_order_number &&
            this.queryForm.multi_order_number.substr(-1) === ','
          ) {
            this.queryForm.multi_order_number =
              this.queryForm.multi_order_number.replace(/\S{1}$/, '')
          }
          if (
            this.queryForm.multi_child_ordernumber &&
            this.queryForm.multi_child_ordernumber.substr(-1) === ','
          ) {
            this.queryForm.multi_child_ordernumber =
              this.queryForm.multi_child_ordernumber.replace(/\S{1}$/, '')
          }

          const data: any = {
            ...this.setForm,
            filters: {
              // ...this.queryForm,
              order_number: this.queryForm.order_number,
              child_ordernumber: this.queryForm.child_ordernumber,
              merchant_no: this.queryForm.merchant_no,
              min_amount: this.queryForm.min_amount,
              max_amount: this.queryForm.max_amount,
              source: this.queryForm.source,
              start_time: this.queryForm.start_time,
              end_time: this.queryForm.end_time,
              multi_order_number: this.queryForm.multi_order_number,
              multi_child_ordernumber: this.queryForm.multi_child_ordernumber,
              status: this.queryForm.status,
              upstream_status: this.queryForm.upstream_status,
              success_start_time: this.queryForm.success_start_time,
              success_end_time: this.queryForm.success_end_time,
              handle_time_unit: timeTypeList[0],
              need_approval: true
            }
          }

          delObjEmptyKey(data)
          await setOneClickUnfreeze(data)
            .then(() => {
              this.$message({
                message: 'Operation successfully!',
                type: 'success'
              })
              this.loading = false
              this.flagStr()
              this.closeOpnekickChange()
              this.select()
            })
            .catch(() => {
              this.loading = false
              this.flagStr()
            })
        }
      })
    }
  }

  private closeOpnekickChange() {
    this.opnekickChangeShow = false
    this.setForm.status = null
    this.setForm.remarks = null
    this.setForm.google_code = ''
    this.queryForm.multi_order_number = ''
    this.queryForm.multi_child_ordernumber = ''
    this.multilength = ''
    this.multiChildlength = ''
    this.hadleGetFilesListApi()
  }

  private closeOnePay() {
    this.dialogVisible5 = false
    this.accountList = []
    this.payForm.product = null
    this.arr = []
    this.payForm.product_accounts = []
    this.queryForm.multi_order_number = ''
    this.queryForm.multi_child_ordernumber = ''
    this.multilength = ''
    this.multiChildlength = ''
    this.checkPlatformAll = false
    this.hadleGetFilesListApi()
  }

  private closeDialog() {
    this.dialogVisible = false
    this.currentOrder = null
    this.hadleGetFilesListApi()
  }

  private closeDialog1() {
    this.dialogVisible1 = false
    this.dialogVisible2 = false
    this.dialogVisible3 = false
    this.dialogVisible4 = false
    this.dialogVisible5 = false
    this.opnekickOut = false
    this.hadleGetFilesListApi()
  }

  private openDrawer(ordernumber: number) {
    this.currentOrdernumber = ordernumber
    this.action = ''
    this.drawer = true
  }

  private closeDrawer(isManual: boolean = false) {
    if (isManual) {
      this.drawer = false
    }
    this.currentOrdernumber = null
    this.hadleGetFilesListApi()
  }

  private select() {
    this.currentPage = 1
    this.paymentOrderStatistics()
    this.hadleGetFilesListApi()
  }

  private currencyChange() {
    AppModule.SetCurrentCurrencyType(this.queryForm.currency)
    this.reset()
  }

  private reset() {
    this.queryForm = {
      currency: this.queryForm.currency,
      merchant_no: null,
      order_number: null,
      child_ordernumber: null,
      start_time: null,
      end_time: null,
      status: null,
      upstream_status: null,
      reverse_order: null,
      source: null,
      handle_time_unit: timeTypeList[0],
      product_name: null,
      product_account_name: null,
      min_amount: null,
      max_amount: null,
      success_start_time: null,
      success_end_time: null,
      multi_order_number: null,
      product_code: 'USDT-TRC20Payout'
    }
    this.handleDate = []
    this.currentPage = 1
    this.dateType = 'Created Time'
    this.date = getCurrentDate()
    this.successDate = getCurrentDate()
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
      this.paymentOrderStatistics()
    })
  }

  private async expandChange(row, expandedRows) {
    this.expandedRows = expandedRows.map(item => item.ordernumber)
    if (expandedRows.length > 0) {
      await this.getPaidList(row)
    }
  }

  private async getPaidList(row: any) {
    const data: any = {
      ordernumber: row.ordernumber
    }
    await getPaidList(data).then((res: any) => {
      row.subOrderList = res
    })
  }

  // 出款统计
  private async paymentOrderStatistics() {
    try {
      let data: any = {
        ...this.queryForm
      }
      await paymentOrderStatistics(data).then((res: any) => {
        this.totalData = res
      })
    } catch (e) {}
  }

  private async exportData() {
    try {
      this.sendLoading = true
      const data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await tableExport(data).then(() => {
        this.$message({
          message: 'The form has been sent to your mailbox, please check it!',
          type: 'success'
        })
        this.sendLoading = false
      })
    } catch (e) {
      this.sendLoading = false
      this.$message({
        message: 'Export failure!',
        type: 'error'
      })
    }
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private setRules = {
    google_code: [
      { required: true, message: 'Please input Google Code', trigger: 'blur' }
    ]
  }
  private async saveClickChange() {
    if (!this.queryForm.status) {
      this.requiredErr = 'Query status is required'
    } else if (
      this.queryForm.status &&
      (!this.setForm.remarks || !this.setForm.status)
    ) {
      this.requiredRemarks = 'Remarks is required'
      this.requiredStatus = 'Status is required'
    } else {
      ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
        if (valid) {
          this.loading = true
          this.flag = true
          if (
            this.queryForm.multi_order_number &&
            this.queryForm.multi_order_number.substr(-1) === ','
          ) {
            this.queryForm.multi_order_number =
              this.queryForm.multi_order_number.replace(/\S{1}$/, '')
          }
          if (
            this.queryForm.multi_child_ordernumber &&
            this.queryForm.multi_child_ordernumber.substr(-1) === ','
          ) {
            this.queryForm.multi_child_ordernumber =
              this.queryForm.multi_child_ordernumber.replace(/\S{1}$/, '')
          }

          const data: any = {
            ...this.setForm,
            filters: {
              // ...this.queryForm,
              order_number: this.queryForm.order_number,
              child_ordernumber: this.queryForm.child_ordernumber,
              merchant_no: this.queryForm.merchant_no,
              min_amount: this.queryForm.min_amount,
              max_amount: this.queryForm.max_amount,
              source: this.queryForm.source,
              start_time: this.queryForm.start_time,
              end_time: this.queryForm.end_time,
              multi_order_number: this.queryForm.multi_order_number,
              multi_child_ordernumber: this.queryForm.multi_child_ordernumber,
              status: this.queryForm.status,
              success_start_time: this.queryForm.success_start_time,
              success_end_time: this.queryForm.success_end_time,
              handle_time_unit: timeTypeList[0],
              need_approval: true
            }
          }
          delObjEmptyKey(data)
          await setOneClickChange(data)
            .then(() => {
              this.$message({
                message: 'Operation successfully!',
                type: 'success'
              })
              this.loading = false
              this.flagStr()
              this.closeOpnekickChange()
              this.select()
            })
            .catch(() => {
              this.loading = false
              this.flagStr()
            })
        }
      })
    }
  }

  private getType(id) {
    let arr = this.orderStatusList.filter(item => {
      if (id === item.id) {
        return item
      }
    })
    return arr[0]
  }

  private async init() {
    this.orderStatusList = await AppModule.GetOrderStatusList()
    this.upstreamStatusList = await AppModule.GetUpstreamStatusList()
    await AppModule.GetConstant().then((res: any) => {
      this.sourceList = res?.WITHDRAW_ORDER_SOUCE_CHOICES
      this.statusList = res?.OUT_ORDER_STATUS_CHOICES
    })
    await this.paymentOrderStatistics()
    await this.hadleGetFilesListApi()
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    this.init()
    this.sysType = getType()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.withdrawReview`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
